<script lang="ts">
  import type { SvelteComponentDev } from "svelte/internal"

  export let href: string
</script>

<a
  {href}
  class={$$props.class}
  on:click
>
  <slot></slot>
</a>

<style lang="scss">
  a {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
